// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"4927b007","70":"e166faee","71":"a137f2a1","195":"cddf9460","293":"186c423b","349":"d4e67835","360":"31e26d34","419":"9fff8a33","606":"5a094703","621":"280f5b65","870":"69d5611e"}[chunkId] + ".chunk.js";
};